<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWorkspaceV2 } from 'dashboard/composables/useWorkspaceV2';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits(['create']);

const { t } = useI18n();
const { isWorkspaceV2 } = useWorkspaceV2();
const showActionsDropdown = ref(false);

const menuItems = [
  {
    label: t('COMPANIES.ACTIONS.CREATE'),
    action: 'create',
    value: 'create',
    icon: 'i-ri-add-line',
  },
];

const handleAction = ({ action }) => {
  if (action === 'create') emit('create');
  showActionsDropdown.value = false;
};
</script>

<template>
  <Button
    v-if="isWorkspaceV2"
    :label="t('COMPANIES.ACTIONS.CREATE')"
    icon="i-ri-add-line"
    class="min-h-11 !rounded-xl"
    @click="emit('create')"
  />
  <div
    v-else
    v-on-clickaway="() => (showActionsDropdown = false)"
    class="relative"
  >
    <Button
      icon="i-ri-more-2-line"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="menuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleAction($event)"
    />
  </div>
</template>
